import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../lib/queryKeys.js';
import {
  getShare,
  removeShareRecipient,
  shareConversation,
  stopSharing,
  updateShareToLatest,
} from './shareClient.js';

/** A conversation's share (owner view) and the changes the owner can make to it. */
export const useSharingLogic = (threadId: string | null) => {
  const qc = useQueryClient();
  const key = queryKeys.agentShare(threadId ?? '');
  const share = useQuery({
    queryKey: key,
    queryFn: () => getShare(threadId ?? ''),
    enabled: threadId !== null,
  });
  const refresh = () => qc.invalidateQueries({ queryKey: key });
  const onSuccess = { onSuccess: refresh };

  return {
    share,
    shareWith: useMutation({
      mutationFn: (body: { userIds: string[]; note?: string }) =>
        shareConversation(threadId ?? '', body),
      ...onSuccess,
    }),
    updateToLatest: useMutation({
      mutationFn: () => updateShareToLatest(threadId ?? ''),
      ...onSuccess,
    }),
    remove: useMutation({
      mutationFn: (userId: string) => removeShareRecipient(threadId ?? '', userId),
      ...onSuccess,
    }),
    stop: useMutation({ mutationFn: () => stopSharing(threadId ?? ''), ...onSuccess }),
  };
};

export type ConversationShareControls = ReturnType<typeof useSharingLogic>;
